import { useQuery } from "@tanstack/react-query";
import { connectionService } from "/app/src/services";
import { Connection } from "/app/src/models";
import { buildParams } from "/app/src/helpers";
import { IconBuilder } from "/app/src/components/icons/IconBuilder";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { HeroChip } from "/app/src/components/HeroUi/Chip";

/**
 * Component for displaying list of connections
 */
export default function ConnectionsList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  //query the list of connections
  const { data: connectionList } = useQuery({
    queryKey: ["connectionsList"],
    queryFn: () => {
      return connectionService.getAll(
        buildParams({
          type: "[nor]PowerPick SQL;PowerPick Web Services",
        }),
      );
    },
    initialData: { connections: [] },
    select: (data: { connections: Connection[] }) => {
      return data.connections;
    },
  });

  const onConnectionClick = useCallback(() => {
    navigate("/settings/connections");
  }, [navigate]);

  const onConnectionEnter = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter") {
        navigate("/settings/connections");
      }
    },
    [navigate],
  );

  return (
    <div>
      {connectionList.map((connection: Connection) => (
        <>
          <div className="grid grid-cols-[200px_1fr] items-center gap-2 h-[45px] ">
            <div className="truncate">
              <span
                tabIndex={0}
                role="button"
                onClick={onConnectionClick}
                className="cursor-pointer text-[#3B8BEA] font-archivo text-[16px]"
                onKeyDown={onConnectionEnter}
              >
                {connection.name}
              </span>
            </div>

            <div aria-hidden className="flex items-center">
              {connection.status === 1 ? (
                <HeroChip
                  onClick={onConnectionClick}
                  startContent={
                    <IconBuilder icon="CircleCheck" color="#054720" size={16} />
                  }
                  className="cursor-pointer flex items-center bg-success-muted"
                  size="sm"
                  color="success"
                >
                  <span className="text-[#054720]">
                    {t("translation:online")}
                  </span>
                </HeroChip>
              ) : (
                <HeroChip
                  onClick={onConnectionClick}
                  startContent={
                    <IconBuilder icon="Warning" color="#A12121" size={16} />
                  }
                  className="cursor-pointer bg-error-muted"
                  size="sm"
                  color="danger"
                >
                  <span className="text-[#A12121]">
                    {t("translation:not_connected")}
                  </span>
                </HeroChip>
              )}
            </div>
          </div>
          <hr />
        </>
      ))}
    </div>
  );
}
